/**
 * Path segment for IQ video-to-components API (joined with iqBaseUrl). idea-MDP-452.
 */
export const IQ_VIDEO_TO_COMPONENTS_PATH = "video_to_components/";

/** Legacy suggest-from-video path (joined with iqBaseUrl). Used when idea-MDP-452 is off. */
export const IQ_INSPECTION_INSTRUCTIONS_FROM_VIDEO_PATH = "inspection_instructions/from_video/";

/**
 * IQ path for “suggest from video” based on idea-MDP-452.
 * @param {boolean} ideaMDP452Enabled
 * @returns {string}
 */
export const resolveVideoSuggestIqPath = (ideaMDP452Enabled) =>
  ideaMDP452Enabled ? IQ_VIDEO_TO_COMPONENTS_PATH : IQ_INSPECTION_INSTRUCTIONS_FROM_VIDEO_PATH;

/**
 * Full POST URL for suggest-from-video (iqBaseUrl + path segment).
 * @param {string} iqBaseUrl
 * @param {boolean} ideaMDP452Enabled
 * @returns {string}
 */
export const buildIqVideoSuggestEndpoint = (iqBaseUrl, ideaMDP452Enabled) => {
  const path = resolveVideoSuggestIqPath(ideaMDP452Enabled);
  return `${String(iqBaseUrl || "")
    .trim()
    .replace(/\/$/, "")}/${path}`;
};

/**
 * Build POST body for /video_to_components/ (FromVideoBody).
 *
 * - Quiz-only: { video_url } only.
 * - Table of contents (no inspection in selection): { video_url } when the request is TOC/quiz-only paths.
 * - Inspection instructions (inspection_only, both, or legacy null): video_url plus context fields and language.
 *
 * @param {Object} params
 * @param {string} params.videoUrl - Raw or iframe-embedded video URL (caller extracts if needed).
 * @param {string} [params.businessPurpose]
 * @param {string} [params.responsibilityName]
 * @param {string} [params.responsibilityPurpose]
 * @param {string} [params.checkpointCriteria] - Combined checkpoint prefix + criteria text.
 * @param {string} [params.language] - "english" | "mexican spanish"
 * @param {{ videoType?: string, testingType?: string } | null} [params.microlearningSelection] - From Generate dialog; null = legacy inspection suggest flow.
 * @returns {Object}
 */
export function buildVideoToComponentsPayload({
  videoUrl,
  businessPurpose = "",
  responsibilityName = "",
  responsibilityPurpose = "",
  checkpointCriteria = "",
  language = "english",
  microlearningSelection = null,
}) {
  const base = { video_url: videoUrl || "" };
  const testingType = microlearningSelection?.testingType ?? null;

  if (testingType === "quiz_only") {
    return base;
  }

  return {
    ...base,
    business_purpose: businessPurpose || "",
    responsibility_name: responsibilityName || "",
    responsibility_purpose: responsibilityPurpose || "",
    checkpoint_criteria: (checkpointCriteria || "").trim(),
    language: language || "english",
  };
}
